import { render, staticRenderFns } from "./TileEditor.vue?vue&type=template&id=2a51a4b2&scoped=true&"
import script from "./TileEditor.vue?vue&type=script&lang=js&"
export * from "./TileEditor.vue?vue&type=script&lang=js&"
import style0 from "./TileEditor.vue?vue&type=style&index=0&id=2a51a4b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a51a4b2",
  null
  
)

export default component.exports